<template>
  <svg
    data-testid="talent-avatar-male"
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3995_13281)">
      <path
        d="M0 199.667H200V-0.000281752H0V199.667Z"
        fill="#D3D5D2"
      />
      <path
        d="M131.517 140.51C131.517 140.51 131.787 164.321 134.955 166.65C138.123 168.979 150.443 174.637 150.443 174.637L149.035 176.301C149.035 176.301 149.387 171.975 152.203 174.637C155.019 177.299 165.227 180.627 165.227 180.627L181.067 188.613C181.067 188.613 190.922 193.605 190.922 195.602C190.922 197.599 190.922 197.599 190.922 197.599H17.0369L33.2287 184.62L45.5486 181.958C45.5486 181.958 49.7723 177.299 51.8845 177.964C53.9964 178.63 53.9964 178.63 53.9964 178.63L69.1323 169.055C69.1323 169.055 73.3559 164.653 73.0041 157.998C72.6519 151.342 72.6519 140.51 72.6519 140.51H131.517Z"
        fill="#E7E7E5"
      />
      <path
        d="M131.517 140.51C131.517 140.51 131.787 164.321 134.955 166.65C138.123 168.979 150.443 175.302 150.443 175.302L152.203 174.637C152.203 174.637 151.147 173.971 153.963 176.633C156.779 179.296 165.227 180.627 165.227 180.627L181.067 188.613C181.067 188.613 190.922 193.605 190.922 195.602C190.922 197.599 190.922 197.599 190.922 197.599H17.0369L33.2287 184.62L45.5486 181.958C45.5486 181.958 49.7723 177.299 51.8845 177.964C53.9964 178.63 53.9964 178.63 53.9964 178.63L69.1323 169.055C69.1323 169.055 73.3559 164.653 73.0041 157.998C72.6519 151.342 72.6519 140.51 72.6519 140.51H131.517Z"
        fill="url(#paint0_linear_3995_13281)"
      />
      <path
        d="M64.5563 108.081C64.5563 108.081 58.9241 93.4386 57.5163 91.1092C56.1082 88.7798 58.5722 80.7933 57.5163 79.1292C56.4604 77.4652 56.1082 53.1725 64.5563 45.8513C73.0041 38.53 77.9318 36.5337 77.9318 36.5337C77.9318 36.5337 78.2841 33.5386 86.0277 33.5386C93.7718 33.5386 87.1551 28.5468 99.7914 30.5435C112.427 32.5402 114.891 32.5403 114.891 32.5403L117.707 32.2072C117.707 32.2072 127.915 36.2007 127.211 40.5268C126.507 44.8529 137.419 40.5268 137.419 40.5268V43.5219C137.419 43.5219 146.571 43.8546 146.571 66.8162C146.571 88.9231 144.862 96.8321 142.347 98.0978C139.832 99.3631 137.067 104.088 137.067 104.088C137.067 104.088 136.363 63.8341 125.099 64.1541C113.835 64.4741 105.58 70.168 78.2841 64.1541C72.3 62.8357 61.3882 100.094 64.5563 108.081Z"
        fill="#999C9B"
      />
      <path
        d="M64.204 122.723C64.204 122.723 63.8522 142.357 82.1559 154.005C100.46 165.652 114.891 156.001 114.891 156.001C114.891 156.001 134.251 141.692 134.603 134.038C134.955 126.384 137.771 122.723 137.771 122.723C137.771 122.723 139.883 122.723 141.291 121.06C142.699 119.396 143.051 108.747 144.107 105.752C145.163 102.757 145.867 97.765 142.347 98.0981C138.827 98.4307 137.067 104.088 137.067 104.088C137.067 104.088 137.771 94.7699 135.659 88.7801C133.547 82.7899 137.419 69.4789 128.971 64.4871C120.523 59.4956 109.766 61.1593 104.585 62.8234C99.4036 64.4871 88.4918 63.4887 81.804 61.1593C75.1159 58.8299 69.484 69.8116 68.4281 74.8034C67.3722 79.7952 63.8514 100.094 64.2036 104.088C64.5563 108.081 64.5563 108.081 64.5563 108.081C64.5563 108.081 62.0922 97.4324 59.9804 96.7667C57.8681 96.1013 53.9963 96.1013 54.7004 104.088C55.4044 112.074 56.2583 105.891 59.2763 120.727C61.0363 129.379 64.204 122.723 64.204 122.723Z"
        fill="#F1F1EF"
      />
      <path
        d="M69.1322 168.721C69.1322 168.721 80.044 184.287 101.294 184.287C131.083 184.287 137.469 170.176 137.469 170.176L138.726 168.082C138.726 168.082 145.515 170.31 148.683 171.642C151.851 172.973 157.59 176.443 165.226 180.294C172.863 184.144 194.09 192.607 193.386 199.595L13.5168 199.798C12.1088 202.128 30.7262 183.489 35.2834 183.843C38.6721 184.106 41.7375 182.508 44.4924 179.961C47.2473 177.414 62.4293 170.637 69.1322 168.721Z"
        fill="#ADB0AD"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3995_13281"
        x1="103.98"
        y1="201.592"
        x2="103.98"
        y2="132.667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop
          offset="1"
          stop-color="#ADAFAD"
        />
      </linearGradient>
      <clipPath id="clip0_3995_13281">
        <rect
          width="200"
          height="200"
          rx="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'DefaultAvatarMale'
}
</script>
